
const digest = '9221f27332b779914a479af4ea52b0b208408b1da2d1c661a4a4657e3b493b94';
const classes = {"wrapper":"_wrapper_tfx1q_1","bar":"_bar_tfx1q_9","shimmer":"_shimmer_tfx1q_1","block":"_block_tfx1q_17 _bar_tfx1q_9","w40":"_w40_tfx1q_22","w70":"_w70_tfx1q_26","w90":"_w90_tfx1q_30"};
const css = `._wrapper_tfx1q_1 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  width: 100%;
}

._bar_tfx1q_9 {
  background: linear-gradient(90deg, #eef0f4 25%, #f6f7f9 37%, #eef0f4 63%);
  background-size: 400% 100%;
  border-radius: 6px;
  height: 16px;
  animation: _shimmer_tfx1q_1 1.4s ease infinite;
}

._block_tfx1q_17 {
  height: 96px;
}

._w40_tfx1q_22 {
  width: 40%;
}

._w70_tfx1q_26 {
  width: 70%;
}

._w90_tfx1q_30 {
  width: 90%;
}

@keyframes _shimmer_tfx1q_1 {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  ._bar_tfx1q_9,
  ._block_tfx1q_17 {
    animation: none;
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  